export enum SKINTYPE {
    SENSITIVE = 'sensitive-skintype',
    VERYDRY = 'very-dry-skintype',
    DRY = 'dry-skintype',
    ANTIAGING = 'anti-aging-skintype',
    COMBINATION = 'combination-skintype',
    OILY = 'oily-skintype',
    NORMAL = 'normal-skintype'
}
